import moment from "moment-timezone";
import shortid from "shortid";
import * as R from "ramda";

const nextBussinessDay = () => {
  const tomorrow = moment().add(1, "days");
  if (R.includes(tomorrow.day(), [6, 7])) {
    return tomorrow.day() === 6
      ? moment().add(3, "days")
      : moment().add(2, "days");
  } else {
    return tomorrow;
  }
};

export const parseRoom = values =>
  R.pipe(
    R.assoc("id", shortid.generate()),
    R.assoc("day", nextBussinessDay().format("L")),
    R.evolve({
      start: start => moment(start).format("HH:mm"),
      end: end => moment(end).format("HH:mm")
    })
  )(values);

export const formatRoom = R.pipe(
  values =>
    R.evolve({
      start: start =>
        moment(`${values.day} ${start}`, "DD/MM/YYYY HH:mm").valueOf(),
      end: end => moment(`${values.day} ${end}`, "DD/MM/YYYY HH:mm").valueOf()
    })(values),
  R.omit(["day"])
);
